/**
 * Touch / coarse-pointer UX: class hook + tap-to-reveal product card overlays.
 * Fine-pointer (mouse) behavior is unchanged via CSS media queries.
 */
(function () {
  const TOUCH_QUERY = '(hover: none), (pointer: coarse)';

  function isTouchLike() {
    return window.matchMedia(TOUCH_QUERY).matches;
  }

  function setTouchClass() {
    document.documentElement.classList.toggle('bhcr-touch', isTouchLike());
  }

  function initProductCardTouchHover() {
    if (!isTouchLike()) return;

    document.addEventListener(
      'click',
      (event) => {
        const card = event.target.closest('.product-card');
        const openCard = event.target.closest('.product-card.is-touch-hover');

        if (!card) {
          document.querySelectorAll('.product-card.is-touch-hover').forEach((el) => {
            el.classList.remove('is-touch-hover');
          });
          return;
        }

        if (card.querySelector('.product-card__purchase')?.contains(event.target)) {
          return;
        }

        if (card.classList.contains('is-touch-hover')) {
          if (openCard === card && event.target.closest('a, button, input, select, textarea, label')) {
            return;
          }
          card.classList.remove('is-touch-hover');
          return;
        }

        document.querySelectorAll('.product-card.is-touch-hover').forEach((el) => {
          if (el !== card) el.classList.remove('is-touch-hover');
        });

        if (event.target.closest('.product-card__media, .product-card__link, .product-card__details')) {
          event.preventDefault();
          card.classList.add('is-touch-hover');
        }
      },
      true
    );
  }

  setTouchClass();
  initProductCardTouchHover();

  window.matchMedia(TOUCH_QUERY).addEventListener('change', setTouchClass);
})();
